import React, {Component} from 'react';
import {Button} from 'react-bootstrap';
import {connect} from 'react-redux';
import $ from 'jquery';
import ReactDOM from 'react-dom'
import './Home.css';
import Footer from "./Footer";
import { Modal } from "react-bootstrap";
import { Cookies } from 'react-cookie';

import {
  Trans,
  
} from "react-i18next";
import { getDesktopPickBtn, getUrlWord, showEmbedFooter } from '../util/helpers/Helpers';


class App extends Component {

  constructor(props) {

    super(props);
    this.state = {
      hideAgeRestrictionPopup: false,
      showAgeRestrictionPopupErr: false
    }
    this.setAgeRestrictionAcceptance = this.setAgeRestrictionAcceptance.bind(this);
  }

  setAgeRestrictionAcceptance = () => {
      const cookies = new Cookies();
      cookies.set('age-restriction-' + this.props.comp.id, true);
      this.setState({
          hideAgeRestrictionPopup: true
      });
  }

  showAgeRestrictionPopupError = () => {
      this.setState({
          showAgeRestrictionPopupErr: true
      });
  }

  componentDidMount() {
    console.log('props',this.props)
  }

  componentDidUpdate(prevProps) {
    if(this.props.comp && this.props.comp.id > 0 && !window.codeInjectedForEntryPage) {

      const codeSamples = this.props.comp.codeSnippetsForInjection || [];
      for(let i = 0; i < codeSamples.length; i++) {
        if(codeSamples[i].page === 'global' && codeSamples[i].htmlTagName && codeSamples[i].codeToBeInjected) {
          $(codeSamples[i].htmlTagName).append(codeSamples[i].codeToBeInjected);
        } else if(codeSamples[i].page === 'entry' && codeSamples[i].codeToBeInjected) {
          $(ReactDOM.findDOMNode(this)).append(codeSamples[i].codeToBeInjected);
        }
      }
      window.codeInjectedForEntryPage = true;
      console.log(this.props.comp);

       // CSS FILES
       var fileref=document.createElement("link")
       fileref.setAttribute("rel", "stylesheet")
       fileref.setAttribute("type", "text/css")
       fileref.setAttribute("href", this.props.comp.cssContentUrl)
       if (typeof fileref!="undefined"){
           document.getElementsByTagName("head")[0].appendChild(fileref);
       }

       // FONT CSS FILES
       var fileref=document.createElement("link")
       fileref.setAttribute("rel", "stylesheet")
       fileref.setAttribute("type", "text/css")
       fileref.setAttribute("href", this.props.comp.fontUrl)
       if (typeof fileref!="undefined"){
           document.getElementsByTagName("head")[0].appendChild(fileref);
       }
    }
  }

  goToVote = () => {
    // let hash = this.props.location.hash;
    // hash = hash ? hash.replace(/(^#)/g, "") : '';
    let hash = getUrlWord(this.props.match.url, this.props.location.hash)

    const showOnlyDesktopPickBtn = getDesktopPickBtn();
    const hasEmbedFooter = showEmbedFooter();
    if (hash.includes("/")) {
      if (showOnlyDesktopPickBtn) {
        if(hasEmbedFooter){
          this.props.history.push(`${hash}/vote?desktop_pick_btn=${showOnlyDesktopPickBtn}&embed=true`)
        }else{
          this.props.history.push(`${hash}/vote?desktop_pick_btn=${showOnlyDesktopPickBtn}`)
        }
      }
      else {
        if(hasEmbedFooter){
          this.props.history.push(`${hash}/vote?embed=true`)
        }else{
          // this.props.history.push(`/vote#${hash}`)
          this.props.history.push(`${hash}/vote`)
        }
      }
    } else if (hash.includes("__CURL_")) {
      if (showOnlyDesktopPickBtn) {
        if (hasEmbedFooter) {
          this.props.history.push(`vote?desktop_pick_btn=${showOnlyDesktopPickBtn}&embed=true`)
        } else {
          this.props.history.push(`vote?desktop_pick_btn=${showOnlyDesktopPickBtn}`)
        }
      }
      else {
        if (hasEmbedFooter) {
          this.props.history.push(`vote?embed=true`)
        } else {
          // this.props.history.push(`/vote#${hash}`)
          this.props.history.push(`vote`)
        }
      }
    } else {
      // [hash removal] remove this after hash migration
      if (showOnlyDesktopPickBtn) {
        if(hasEmbedFooter){
          this.props.history.push(`/vote?desktop_pick_btn=${showOnlyDesktopPickBtn}&embed=true#${hash}`)
        }else{
          this.props.history.push(`/vote?desktop_pick_btn=${showOnlyDesktopPickBtn}#${hash}`)
        }
      }
      else {
        if(hasEmbedFooter){
          this.props.history.push(`/vote?embed=true#${hash}`)
        }else{
          this.props.history.push(`/vote#${hash}`)
        }
      }
    }
  }

  render() {

    const cookies = new Cookies();
    let modalContent = '';
    console.log('props-new', this.props.comp);
    if (this.props.comp && this.props.comp.showAgeRestrictionPopup) {
        console.log('p-nish', this.props.comp.showAgeRestrictionPopup);
        modalContent = (<Modal show={!cookies.get('age-restriction-' + this.props.comp.id)}
            dialogClassName={"age-restrict-dialog-wrapper " + (noBorderRadius ? 'no-border-radius' : '')}>
            <Modal.Body>
                <div className={"age-restrict-dialog"}>
                    <div className={"modal-body"}>
                        <h3><Trans i18nKey="are_you_over_18" /></h3>
                    </div>
                    <div className={"modal-footer"}>
                        <button type="button" className={"btn btn-default"}
                            onClick={this.setAgeRestrictionAcceptance}><Trans i18nKey="yes" /></button>

                        <button type="button" className={"btn btn-default"}
                            onClick={this.showAgeRestrictionPopupError}><Trans i18nKey="no" /></button>
                        {this.state.showAgeRestrictionPopupErr ?
                            <div className={"modal-error"}><Trans i18nKey="are_you_over_18_err" /></div>
                            : ''
                        }
                    </div>
                </div>
            </Modal.Body>
        </Modal>);
    }


    const showOnlyDesktopPickBtn = getDesktopPickBtn();

    const {comp} = this.props;
    if (!comp.id) {
      return <div></div>;
    }

    let noBorderRadius = (comp && comp.defaultShape == 2);
    
    return (
      <div className={(noBorderRadius ? 'no-border-radius' : '')}>
        <div className='app' id='app-page-1'>
          {modalContent}
          <div className={'intro'}>
            {comp.logoBg || (comp.sponsorsBg && comp.sponsorsTop) ? (
              <div>
                {comp.logoBg ? (
                  <div className={'logos-cont'}>
                    <img src={comp.logoBg.file} className={'logo-image'}/>
                  </div>
                ) : null}
                {comp.sponsorsBg && comp.sponsorsTop ? (comp.sponsorsLink && comp.sponsorsLink != '') ? (
                  <a href={comp.sponsorsLink} target="_blank">
                    <div className={'logos-cont'}>
                      <img src={comp.sponsorsBg.file} className={'logo-image sponsors'}/>
                    </div>
                  </a>
                ) : (
                  <div className={'logos-cont'}>
                    <img src={comp.sponsorsBg.file} className={'logo-image sponsors'}/>
                  </div>
                ) : null}
              </div>
            ) : null}
            <h1 className={'site-title'} style={{color: comp.primaryColor}} dangerouslySetInnerHTML={{__html: comp.detail}}/>
            <p className={'site-description'} style={{color: comp.primaryColor}} dangerouslySetInnerHTML={{__html: comp.description}}/>
            <div className={(showOnlyDesktopPickBtn ? 'go-to-vote-cont-desktop' : 'go-to-vote-cont')}>
              <div>
                <Button bsStyle="primary pick-now-btn"
                        style={{backgroundColor: comp.buttonColor, color: comp.secondaryColor}}
                        onClick={this.goToVote}>
                        {comp.enterCopy?comp.enterCopy:<Trans i18nKey="pick_now" />}
                        </Button>
              </div>
              {/* removed this and pick arrow on Adam's request on Sep 18 2020 */}
              {/* <p style={{color: comp.primaryColor}}
                 className={'it'}><Trans i18nKey="pick_skill" /></p> */}
            </div>
            {comp.sponsorsBg && !comp.sponsorsTop ? (comp.sponsorsLink && comp.sponsorsLink != '') ? (
              <a href={comp.sponsorsLink} target="_blank">
                <div className={'logos-cont logos-bottom'}>
                  <img src={comp.sponsorsBg.file} className={'logo-image sponsors'}/>
                </div>
              </a>
            ) : (
              <div className={'logos-cont logos-bottom'}>
                <img src={comp.sponsorsBg.file} className={'logo-image sponsors'}/>
              </div>
            ) : null}
          </div>
        </div>
        
        <Footer tncs={comp.tncs} privacypolicy={comp.privacypolicy} showMadeWithBv={comp.showMadeWithBv} />

      </div>
    );
  }
}

//-------------------------------------------------------------------------
//-------------------- Mapping store to App's props ----------------------
//-------------------------------------------------------------------------

const mapStateToProps = (state, ownProps) => {

  const prj = state.Project;
  
  console.log(state);
  return {
    ...ownProps,
    comp: state.default.bulldogs.competition,
    locale:state.default.locale
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);